module.exports = __webpack_public_path__ + "img/768_online_ticket_qr.e6e8dd09.svg";